import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QaLocatorsModule } from '@metromarkets/sdk';
import { ProductCardComponent, ProductSuggestionComponent } from '~shared/modules/product-card/components';
import { KebabCaseModule } from '~shared/pipes';
import { DefaultImageModule } from '~shared/directives/default-image/default-image.module';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { MmButtonModule, MmFlexLayoutModule, MmIconModule, MmQuantityPickerModule } from '@metromarkets/components';
import { LazyLoadImageModule } from '~shared/directives/lazyload/lazy-load-image.module';
import { OffersLabelModule } from '~shared/components/offers-label/offers-label.module';
import { ProductPromotionModule } from '~shared/modules/product-promotion/product-promotion.module';
import { ProductLimitedStockLabelModule } from '~shared/components/product-limited-stock-label/product-limited-stock-label.module';
import { DisableClickEventModule } from '~app/modules/storyblok/directives/disable-click-event/disable-click-event.module';
import { PDPNavigatorModule } from '~shared/modules/pdp-navigator/pdp-navigator.module';
import { ProductCardVariantsComponent } from '~shared/modules/product-card/components/product-card-variants/product-card-variants.component';
import { ProductDiscountLabelModule } from '~shared/modules/product-discount-label';
import { VariantsSelectorComponent } from '~shared/modules/product-card/components/variants-selector';
import { VariantsPriceComponent } from '~shared/modules/product-card/components/variants-price';
import { EnergyLabelScaleService } from '~shared/modules/product-card/services/energy-label-scale.service';
import { PlpAddToCartQuantityCheckTooltipComponent } from '~shared/modules/product-card/components/quantity-check-tooltip/quantity-check-tooltip.component';
import { ProductEnergyEfficiencyNewComponent } from '~shared/modules/product-card/components/product-energy-efficiency-new';
import { EnergyLabelModule } from '../energy-label';

@NgModule({
  declarations: [
    ProductCardComponent,
    ProductCardVariantsComponent,
    ProductSuggestionComponent,
    ProductEnergyEfficiencyNewComponent,
    VariantsSelectorComponent,
    VariantsPriceComponent,
    PlpAddToCartQuantityCheckTooltipComponent,
  ],
  imports: [
    CommonModule,
    MmFlexLayoutModule,
    QaLocatorsModule,
    KebabCaseModule,
    DefaultImageModule,
    RouterModule,
    TranslateModule,
    LazyLoadImageModule,
    MmIconModule,
    OffersLabelModule,
    ProductPromotionModule,
    ProductDiscountLabelModule,
    ProductLimitedStockLabelModule,
    DisableClickEventModule,
    PDPNavigatorModule,
    MmQuantityPickerModule,
    MmButtonModule,
    EnergyLabelModule,
  ],
  providers: [EnergyLabelScaleService],
  exports: [
    ProductCardComponent,
    ProductSuggestionComponent,
    ProductCardVariantsComponent,
    VariantsSelectorComponent,
    ProductEnergyEfficiencyNewComponent,
  ],
})
export class ProductCardModule {}
